import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PassTest from "../../components/PassTest/PassTest";
import Result from "../../components/TestResult/TestResult";
import { TestContext } from "../../context/testContext";
import Loader from "../../UI/Loader/Loader"; 
import СoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import { AuthContext } from "../../context/authContext";
 
const TestPass = () => {
  const {
    tests,
    getTestById,
    updatePassingTest,
    passingTest,
    postTestById,
    testContinue,
    finish,
    setFinishWithoutAnswers,
    updateTimer
  } = useContext(TestContext);

    

  const { logout, currentUser } = useContext(AuthContext);

  const navigate = useNavigate();

  const [test, setTest] = useState(null);
  const [switchTest, setSwitchTest] = useState(false)

  const [currentTestId, setCurrentTestId] = useState(0);

  const skipTest = () => {
    setSwitchTest(true)
    setCurrentTestId((prev) => {
      if (prev === passingTest.length - 1) return 0;
      return prev + 1;
    });
    
    setSwitchTest(false)
  };

  const sendAnswer = (answer) => {
    if (passingTest.length === 1) {
      setSwitchTest(true)
      postTestById(
        currentUser.iin,
        passingTest[currentTestId],
        answer
      ).finally(() => {
        setSwitchTest(false)
      });
    } else {
      setSwitchTest(true) 
      postTestById(
        currentUser.iin,
        passingTest[currentTestId],
        answer
      ).then(()=> {
        updatePassingTest(passingTest[currentTestId]);
      }).then(() => {
        setCurrentTestId((prev) => {
          if (prev === passingTest.length - 1) return 0;
          return prev;
        });
      }).then(() => {
        getTestById(
          currentUser.iin,
          passingTest[currentTestId],
          answer
        ).then((res) => {
            setTest(res.data);
          })
          .catch((err) => {
            if (err.response.status === 401) {
              logout();
            }
          }).finally(() => {
            setSwitchTest(false)
          })
          ;
      });
     
      
     
      
    }
  };

  useEffect(() => {
    document.title = "Тестирование"
    if (!passingTest && !finish) { 
      
      navigate("/test", { replace: true }); 
    }
    if (!finish && passingTest) {
  
      getTestById( 
        currentUser.iin,
        passingTest[currentTestId]
      )
        .then((res) => {
          setTest(res.data);
        })
        .catch((err) => {
     
          if (err.response.status === 401) {
            logout();
          }
        })
    }

  }, [currentTestId, passingTest]);

  return (
    <div className="container">
      {
      

        !finish ? (
          !test ? (
            <div style={{ position: "relative", height: 350 }}>
              <СoveredBackground>
                <Loader />
              </СoveredBackground>
            </div>
          ) : (
            <PassTest
              test={test}
              updateTimer={updateTimer}
              switchTest={switchTest}
              skipTest={skipTest}
              testsNumber={
                testContinue ? testContinue.total_ball : tests.length
              }
              setFinishWithoutAnswers={setFinishWithoutAnswers}
              passTestsNumber={
                testContinue
                  ? JSON.parse(testContinue.answers).length +
                    tests.length -
                    passingTest.length
                  : tests.length - passingTest.length
              }
              sendAnswer={sendAnswer}
            />
          )
        ) : (
          <Result
            currentResult={finish.current_ball}
            totalResult={finish.total_ball}
          />
        )
      }
    </div>
  );
};

export default TestPass;
